import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { Select } from 'antd';
import { Package } from '../../../common/models';
import './InputPackageSelector.less';

type Props = {
    packages: Package[];
    isLoadingPackages: boolean;
    value?: string[];
    onChange?: (value: string[]) => void;
    placeholder?: string;
};

const InputPackageSelector: React.FC<Props> = ({
    packages,
    isLoadingPackages,
    value,
    onChange,
    placeholder = 'Select packages'
}) => {
    const options = React.useMemo(() => {
        return packages.map(pkg => ({
            value: pkg.id,
            label: pkg.name,
            title: pkg.name
        }));
    }, [packages]);

    return (
        <Select
            className="input-package-selector"
            mode="multiple"
            value={value}
            onChange={onChange}
            placeholder={isLoadingPackages ? 'Loading packages...' : placeholder}
            loading={isLoadingPackages}
            options={options}
            showSearch
            filterOption={(input, option) =>
                (option?.label?.toString() || '').toLowerCase().includes(input.toLowerCase())
            }
        />
    );
};

export default observer(InputPackageSelector);
